import { createFileRoute } from '@tanstack/react-router';

import { ModulePlaceholder } from '../components/module-placeholder';
import { requireOnboardingForPublicRoute } from '../features/onboarding/require-onboarding';
import { MODULE_INTRO } from '../lib/module-intro';

export const Route = createFileRoute('/community')({
  beforeLoad: ({ context }) =>
    requireOnboardingForPublicRoute({ queryClient: context.queryClient }),
  component: () => <ModulePlaceholder {...MODULE_INTRO.community} />,
});
